import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class DockAppointments_ds_get_dock_appointment_type_by_nameService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { name: string }): 
  Promise<{ result: { Id?: number, Name?: string } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.name)) {
      missingRequiredInParams.push('\'name\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/DockAppointments/datasources/ds_get_dock_appointment_type_by_name/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      name: string    }) {
        if(isNil(inParams.name)) {
          return true; 
        }
      return false;
    }
}
